import React, {forwardRef, useImperativeHandle, useState} from 'react'
import {Modal} from "@/Components/Modal";
import {XCircle} from "react-feather";
import {Emma} from "@/Components/Emma";
import {LabeledInput} from "@/Components/Form";
import {usePage} from "@inertiajs/inertia-react";
import {Inertia} from "@inertiajs/inertia";
import {SuccessMessage} from "@/Components/Messages";

export const PlanUpgradeNotice = forwardRef(({title = null, subtitle = null, marginbottom = 'mb-8'}, ref) => {

  const errors = usePage().props?.errors|| {}
  const flash = usePage().props?.flash|| {}
  const user = usePage().props?.auth?.user?.data || null

  const [modalOpen, setModalOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [organizationNumber, setOrganizationNumber] = useState('');
  const [phone, setPhone] = useState('');

  useImperativeHandle(ref, () => ({
    triggerOpenModal() {
      setModalOpen(true)
    }
  }));

  const submitUpgradeRequest = (e) => {
    e.preventDefault();

    if (isDisabled()) {
      return;
    }

    let data = {
      email: email,
      phone: phone,
    }

    if (!user) {
      data.organization_number = organizationNumber;
    }

    Inertia.post('/plan-upgrade-request/custom', data, {
      onSuccess: () => {
        setEmail('');
        setPhone('');
        setOrganizationNumber('');
      },
    });
  }

  const isDisabled = () => {
    return email === '' || phone === '';
  }


  return <>
    {title ?
      <div className={`p-8 bg-apricot flex justify-between flex-col md:flex-row ${marginbottom}`}>
        <div>
          <h3 className="text-lg font-semibold text-white">{title}</h3>
          <p>{subtitle}</p>
        </div>

        <button className="flex-shrink-0 btn-blue-outline mt-4 md:mt-0" onClick={() => setModalOpen(true)}>Contact us to upgrade</button>

      </div>
    : null}

    {modalOpen && (
      <Modal center={true} width="w-full md:max-w-3xl" setVisible={setModalOpen}>
        <div className="w-full p-8 bg-apricot-light border-t shadow-xl relative">
          <XCircle className="absolute p-2 cursor-pointer right-4" size={42} onClick={() => setModalOpen(false)}/>

          {flash.status && (
            <SuccessMessage>{flash.status}</SuccessMessage>
          )}

          <div className="md:p-8 flex flex-col">
            <p className="bg-apricot text-white leading-none rounded-br-xl py-4 px-4 self-start ">Time to level up?</p>

            <div className="mt-8 flex justify-between">
              <div>
                <h2 className="text-xl font-semibold mb-2">With Emma Custom you get</h2>
                <ul className="list-disc ml-4">
                  <li>Unlimited teams</li>
                  <li> Custom activities, as many as you need</li>
                  <li> Custom emission factors</li>
                  <li>And we set it all up for you</li>
                </ul>
              </div>
              <Emma className="hidden w-20 sm:block" color="green"/>
            </div>

            <p className="py-8">Fill out your contact information and we’ll get back to you soon</p>

            <form onSubmit={submitUpgradeRequest}>
              <LabeledInput
                title="E-mail"
                placeholder="Enter e-mail"
                name="email"
                type="email"
                required="required"
                className="mb-4"
                value={email}
                onChange={event => setEmail(event.target.value)}
                error={errors.email}
              />

              {!user && (
                <LabeledInput
                  title="Organization number"
                  placeholder="Enter organization number"
                  name="organization_number"
                  required="required"
                  className="mb-4"
                  value={organizationNumber}
                  onChange={event => setOrganizationNumber(event.target.value)}
                  error={errors.organization_number}
                />
              )}

              <LabeledInput
                title="Contact phone number"
                placeholder="Enter phone number"
                name="phone"
                required="required"
                className="mb-4"
                value={phone}
                onChange={event => setPhone(event.target.value)}
                error={errors.phone}
              />

              <div className="flex flex-row justify-end">
                <button type="button" className="ml-4 underline hover:no-underline text-blue" onClick={() => setModalOpen(false)}>Never mind</button>
                <button disabled={isDisabled()} className="flex-grow-0 px-4 py-2 ml-4 btn-blue disabled:opacity-75">Send</button>
              </div>

            </form>

          </div>

        </div>
      </Modal>
    )}
  </>
});
